import { z } from 'zod';

// Frontend Filters schema (UI shape):
// days: { mon..sun: boolean }, session: array of [start,end] or {start,end}
export const filtersSchema = z.object({
  days: z.object({
    mon: z.boolean(),
    tue: z.boolean(),
    wed: z.boolean(),
    thu: z.boolean(),
    fri: z.boolean(),
    sat: z.boolean().optional(),
    sun: z.boolean().optional(),
  }),
  session: z.array(
    z.union([
      z.tuple([z.string(), z.string()]),
      z.object({ start: z.string(), end: z.string() })
    ])
  ),
});

export default filtersSchema;
